import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.SESSION_TOGGLE_LOADING);
  axios
    .get("/api/sessions/")
    .then((response) => {
      commit(types.SESSION_TOGGLE_LOADING);
      commit(types.SESSION_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.SESSION_TOGGLE_LOADING);
      commit(types.SESSION_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.SESSION_RESET);
};
